export const data = {
  "s0": {
    title: `Мир против серы`,
    short: `Для сохранения экологии разрешено использовать судовое топливо с содержанием серы не более 0,5%, а в некоторых особых зонах мореплавания — 0,1% и ниже.`,
    text: `
    <div>
      В 1973 году была принята международная конвенция по предотвращению загрязнения с судов (MARPOL). Она защищает окружающую и, в частности, морскую среду и устанавливает нормативы содержания веществ в судовых топливах. Так, уровень серы в них не должен превышать 0,5%, а в особых зонах контроля, где к выбросам предъявляются еще более строгие требования, — не более 0,1%. К последним относится и Балтийское море. Это значит, что курсирующие по нему суда заправляются только экологичным топливом.
    </div>
    `,
    img: ['modal/s0.svg'],
    imgMob: ['modal/s0_mob.svg'],
  },
  "s1": {
    title: `Почему СПГ?`,
    short: `Наиболее экологичное судовое топливо, соответствующее международным стандартам, — природный газ. Он вообще не содержит серы.`,
    text: `
    <div>
      Наиболее экологичным и безопасным судовым топливом, соответствующим требованиям MARPOL, считается сжиженный природный газ (СПГ). Это преимущественно метан, искусственно сжиженный при температурах ниже -160°C. При такой низкой температуре объем газа уменьшается в 600 раз, при этом он пожаробезопасен — значит, его удобно хранить и перевозить. Кроме того, СПГ не страшны разливы топлива: ни одного подобного случая не зафиксировано.
      <br/><br/>
      Поэтому по сравнению с традиционным судовым топливом СПГ отводится ключевая роль в декарбонизации морских перевозок.
    </div>
    `,
    img: ['modal/s1.svg'],
    imgMob: ['modal/s1.svg'],
  },
  "s2": {
    title: `Шаг в будущее`,
    short: `Для заправки судов СПГ используется не так давно — с 2000-х годов. Поэтому наиболее актуальные задачи сейчас — создание СПГ-инфраструктуры и подготовка нормативной базы.`,
    text: `
    <div>
      СПГ в качестве судового топлива стал использоваться относительно недавно — в 2000-х годах. Закрепить успех поможет создание полноценной СПГ-инфраструктуры в портах всего мира, но первый шаг — подготовка нормативной базы. 
      <br/><br/>
      В России созданием рыночного сегмента по заправке судов газомоторным топливом занимается «Газпром нефть», системно внедряя новые стандарты и регламенты. В 2018 году компания инициировала введение в России международного стандарта по бункеровке СПГ-топливом, а в 2020 году первой из российских нефтяных компаний вошла в состав международного сообщества СПГ‑бункеровщиков.
    </div>
    `,
    img: ['modal/s2_1.svg', 'modal/s2_2.svg'],
    imgMob: ['modal/s2_1.svg', 'modal/s2_2_mob.svg'],
  },
  // "s3": {
  //   title: ``,
  //   short: ``,
  //   text: `
  //   <div>
  //     Видите облако дыма? Это судно ходит на традиционном топливе — увы, СПГ ему не подходит.
  //   </div>
  //   `,
  // },
  "s3": {
    title: `Первый в России `,
    short: `Вы управляете первым в России судном-бункеровщиком «Дмитрий Менделеев». Его построила «Газпром нефть» для заправки грузовых и пассажирских судов природным газом.`,
    text: `
    <div>
      В 2021 году «Газпром нефть» построила первый в России бункеровщик для заправки грузовых и пассажирских судов экологичным природным газом. Судно названо в честь великого русского ученого-химика Дмитрия Менделеева. Оно способно круглый год выполнять бункеровки и перевозки СПГ, в том числе благодаря ледовому классу Arc4, в замерзающих портах Финского залива и Балтийского моря.
      <br/><br/>
      Все оборудование судна соответствует международной конвенции MARPOL и сертифицировано по экологическому стандарту ECO-S.
    </div>
    `,
    img: [],
    imgMob: [],
  },
  "s4": {
    title: `Экстремальное охлаждение`,
    short: `СПГ на судне хранится при температуре −153 °С и ниже. Это удобно: при такой температуре газ становится жидким, и его объем уменьшается в 600 раз!`,
    text: `
    <div>
      Бункеровщик не только обеспечивает экологичную заправку судов, но и сам безопасен для среды, так как использует в качестве моторного топлива отпарной газ из СПГ. На судне установлены два топливных резервуара, которые обеспечивают безопасное хранение природного газа в сжиженном состоянии при температуре −153 °С и ниже. 
      <br/><br/>
      Также бункеровщик «Дмитрий Менделеев» оснащен криогенным оборудованием: насосами и трубопроводами для погрузки и выгрузки СПГ, системой захолаживания грузовых танков.
    </div>
    `,
    img: ['modal/s4.svg'],
    imgMob: ['modal/s4.svg'],
  },
  "s5": {
    title: `«Борт в борт»`,
    short: `Заправлять корабли можно не только в порту, но и на море. Современные системы проводят заправку по технологии ship-to-ship — «борт в борт».`,
    text: `
    <div>
      «Дмитрий Менделеев» осуществляет бункеровку по технологии ship-to-ship — то есть, «борт в борт», с учетом принципа нулевого сброса. Благодаря этой технологии бункеровку можно проводить у причала или на рейде в порту — прямо во время грузо-пассажирских операций. Благодаря цифровой интегрированной системе судном управляет один человек, а за бункеровку отвечает команда специалистов.
    </div>
    `,
    img: [],
    imgMob: [],
  },
}